import { Button, Stack, Typography } from '@mui/material'
import { User } from 'api/model'
import MailOutlineIcon from '@mui/icons-material/MailOutline'
import { orgsResendInvitation } from 'api/endpoints/jelledFromFileSpecWithTransformer'
import { useSetRecoilState } from 'recoil'
import { toastAtom } from 'state'

const UserStatus = ({
  organizationId,
  user,
  canReinvitePendingUsers,
}: {
  organizationId?: string | null
  user: User
  canReinvitePendingUsers: boolean
}) => {
  const setToast = useSetRecoilState(toastAtom)

  const status = user.profiles.find((up) => up.organization.id === organizationId)?.status
  const isPending = status === 'pending'

  const label = () => {
    switch (status) {
      case 'active':
        return 'Active'
      case 'pending':
        return 'Pending'
      default:
        return status
    }
  }

  const color = () => {
    switch (status) {
      case 'active':
        return '#2BB04F'
      case 'pending':
        return '#999999'
      default:
        return null
    }
  }

  const onResendClick = async () => {
    if (!organizationId) {
      return
    }

    try {
      await orgsResendInvitation(organizationId, user.id)
      setToast({ title: 'Invitation resent successfully', severity: 'success' })
    } catch (error) {
      // TODO: handle errors
    }
  }

  return (
    <Stack direction="row" spacing={2} alignItems="center">
      <Typography variant="h6" sx={{ color: color() }}>
        {label()}
      </Typography>

      {canReinvitePendingUsers && isPending && (
        <Button variant="text" startIcon={<MailOutlineIcon />} onClick={onResendClick}>
          Resend email invite
        </Button>
      )}
    </Stack>
  )
}

export default UserStatus
